import { Typography, Theme, withStyles } from '@material-ui/core'
import { FC, Fragment } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { closeDialog } from '../../../actions/dialogs'
import { createShowings, setShowingApplicants } from '../../../actions/showings'
import { CloseDialog } from '../../../actions/types'
import {
  getApplicationsNameIdPairs,
  selectSelectedApplications
} from '../../../selectors/applications'
import { selectContentIdFromPathname } from '../../../selectors/router'
import { MuiClasses } from '../../../types'
import { Showing } from '../../../types/showings'
import { CreateShowingsFormState, StateInterface } from '../../../types/states'
import { getApplicationNameFromId } from '../../../utils/applications'
import { bindSubmitActionToPromise } from '../../../utils/forms'
import Dialog from '../../Dialog'
import EditShowingForm from '../Edit/EditShowingForm'
import { CreateShowingsForm } from './Forms'

interface ConfirmDialogProps {
  classes: MuiClasses
  edit?: boolean
  showing?: Showing
}
interface StateProps {
  selectedApplications: string[]
  applicationNameIdPairs?: any[]
}

interface DispatchProps {
  closeDialog: CloseDialog
  createShowingsAction: (formData: CreateShowingsFormState) => void
  dispatchSetShowingApplicants: (arg: { applicationIds: string[] }) => void
}

type ComponentProps = ConfirmDialogProps &
  StateProps &
  DispatchProps &
  WithTranslation

const styles = ({ breakpoints, spacing }: Theme) => ({
  invitationDialog: {
    fontFamily: 'CircularRegular'
  }
})

const ConfirmDialog: FC<ComponentProps> = ({
  classes,
  edit,
  selectedApplications,
  applicationNameIdPairs,
  closeDialog,
  createShowingsAction,
  t,
  dispatchSetShowingApplicants,
  showing
}) => {
  const getApplicantName = (id: string) =>
    getApplicationNameFromId(applicationNameIdPairs, id)

  const handleSetShowingApplicants = () => {
    if (!showing) {
      return
    }

    const previousApplications: string[] = showing.invitedApplicationIds
      ? showing.invitedApplicationIds
      : []
    dispatchSetShowingApplicants({
      applicationIds: [...previousApplications, ...selectedApplications]
    })
    closeDialog('ShowingsConfirmationEditDialog')
  }

  return (
    <Fragment>
      {edit ? (
        <Dialog
          dialogId={'ShowingsConfirmationEditDialog'}
          title={t('showings.createShowings.confirmShowingsTitle')}
          noOpenDialogButton
          Content={
            <div className={classes.invitationDialog}>
              <Typography variant='h6'>
                {t('showings.invite.aboutToInvite')}
              </Typography>
              <ol>
                {selectedApplications.map((application) => (
                  <li key={application}>{getApplicantName(application)}</li>
                ))}
              </ol>
              <EditShowingForm
                closeDialog={closeDialog}
                editShowingAction={handleSetShowingApplicants}
              />
            </div>
          }
        />
      ) : (
        <Dialog
          dialogId={'ShowingsConfirmationDialog'}
          title={t('showings.createShowings.confirmShowingsTitle')}
          noOpenDialogButton
          Content={
            <div>
              <Typography variant='h6'>
                {t('showings.invite.aboutToInvite')}
              </Typography>
              <ul>
                {selectedApplications.map((application) => (
                  <li key={application}>{getApplicantName(application)}</li>
                ))}
              </ul>
              <CreateShowingsForm
                {...{
                  isConfirmDialog: true,
                  closeDialog,
                  createShowingsAction
                }}
              />
            </div>
          }
        />
      )}
    </Fragment>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)
  return {
    selectedApplications: selectSelectedApplications(state),
    applicationNameIdPairs: apartmentId
      ? getApplicationsNameIdPairs(apartmentId, state)
      : undefined
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeDialog: (id: string) => dispatch(closeDialog(id)),
  createShowingsAction: bindSubmitActionToPromise(dispatch, createShowings),
  dispatchSetShowingApplicants: (args: { applicationIds: string[] }) =>
    dispatch(setShowingApplicants(args))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(ConfirmDialog)))
